import { render } from "./SvgElement.vue?vue&type=template&id=152f240f&scoped=true"
import script from "./SvgElement.vue?vue&type=script&lang=js"
export * from "./SvgElement.vue?vue&type=script&lang=js"

import "./SvgElement.vue?vue&type=style&index=0&id=152f240f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152f240f"]])

export default __exports__